import { Injectable } from '@angular/core';
import { CommonService } from '../../commons/services/common.service';

@Injectable()
export class GestionClient {
    /**
     * Get client details
     * @param id : clefClient
     */
    public static getClient(id, loadChantier, common: CommonService) {
        const param = {
            'servlet': 'DBGetClient',
            'module': 'Recylog',
            'type': 'map',
            'compression': 'true',
            'data': {
                'CLEF_CLIENT': {
                    'typeParam': 'int',
                    'valeur': id
                },
                'CLEF_SITE': {
                    'typeParam': 'int',
                    'valeur': common.user[2]
                },
                'LOAD_CHANTIER': {
                    'typeParam': 'boolean',
                    'valeur': loadChantier
                },
            }
        };

        return common.post('', { param: param }, true);
    }

    public static desactiverModeProspectClient(client, common: CommonService) {
        if (common.local.getObject('paramSociete').isGestionClientHolding) {
            // N'est pas encore géré
            console.log('societe.isGestionClientHolding n\'est pas encore géré');
        } else {
            const param = {
                'servlet': 'DBDesactiverModeProspectClient',
                'module': 'Recylog',
                'type': 'map',
                'compression': 'false',
                'data': {
                    'CLEF_CLIENT': {
                        'typeParam': 'int',
                        'valeur': client['id']
                    },
                    'CODE_CLIENT': client['codeClient'],
                    'CLEF_SITE': {
                        'typeParam': 'int',
                        'valeur': common.user[2]
                    },
                    'CLEF_USER': {
                        'typeParam': 'int',
                        'valeur': common.user[0]
                      }
                }
            };

            return common.post('', { param: param }, true);
        }
    }
}
